import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Sufism from "@/pages/Sufism";
import Services from "@/pages/Services";
import BookOnline from "@/pages/BookOnline";
import Followers from "@/pages/Followers";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import TheBook from "@/pages/TheBook";
import AdminBook from "@/pages/AdminBook";
import AdminAnalytics from "@/pages/AdminAnalytics";
import MeccaMajlis from "@/pages/MeccaMajlis";

function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-center" />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/sufism" element={<Sufism />} />
          <Route path="/services" element={<Services />} />
          <Route path="/the-book" element={<TheBook />} />
          <Route path="/admin/book" element={<AdminBook />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin" element={<AdminAnalytics />} />
          <Route path="/book" element={<BookOnline />} />
          <Route path="/mecca-majlis" element={<MeccaMajlis />} />
          <Route path="/pricing" element={<Navigate to="/mecca-majlis" replace />} />
          <Route path="/followers" element={<Followers />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
